<div class="main-container">
    <div class="modal-header">
        <span class="modal-main-title">{{data.title.key | translate}}</span>
        <img src="../../../assets/svg/close-button.svg" class="modal-close-btn" (click)="closeModal(false);$event.stopPropagation()">
    </div>
    <div class="modal-body" (click)="$event.stopPropagation()">
        <div class="frequencie-container start-date">
            <span class="project-frequencie-main-container-title">{{data.subtitle.key | translate}}</span>
            <div *ngFor="let option of data.startDateOptions" 
                [ngClass]="{
                    'active': selectedStartDateOption === option.value,
                    'custom-padding': option.hasCalendar
                }" 
                class="start-date-option">
                <p-radioButton
                    [inputId]="option.value"
                    name="startDateOption"
                    [value]="option.value"
                    [label]="(option.labelKey | translate)"
                    [(ngModel)]="selectedStartDateOption">
                </p-radioButton>
                <div *ngIf="option.hasCalendar" class="calendar-wrapper">
                    <img class="calendar-icon" (click)="startDateCalendar?.toggle()" src="../../../../../assets/svg/m_info_icon_calendar.svg">
                    <p-calendar
                        #startDateCalendar
                        id="projectStartDate"
                        [(ngModel)]="selectedStartDate"
                        [showIcon]="false"
                        dateFormat="d MM y"
                        [showButtonBar]="true"
                        class="date-calendar"
                        (keydown.enter)="$event.preventDefault();$event.stopPropagation()">
                    </p-calendar>
                </div>
            </div>
        </div>
        <div class="buttons-container">
            <button pButton [ngClass]="button.className" [label]="(button.labelKey | translate)" *ngFor="let button of data.buttons" (click)="closeModal(button.value);$event.stopPropagation()"></button>
        </div>
    </div>
        
</div>